var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDeviceSwitchWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4353 21.0588C10.7829 20.4071 11.4614 20 12.2 20H57.8C58.5386 20 59.2171 20.4071 59.5647 21.0588L66.7647 34.5588C66.9192 34.8485 67 35.1717 67 35.5V48C67 49.1046 66.1046 50 65 50H5C3.89543 50 3 49.1046 3 48V35.5C3 35.1717 3.08081 34.8485 3.23529 34.5588L10.4353 21.0588Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2222 34H4.77778C3.79594 34 3 34.7163 3 35.6V48.4C3 49.2837 3.79594 50 4.77778 50H65.2222C66.2041 50 67 49.2837 67 48.4V35.6C67 34.7163 66.2041 34 65.2222 34Z",
    fill: "url(#paint0_linear_974_10250)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.971 38H24V40.9636H26.971V38Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.971 43.9268H24V46.8904H26.971V43.9268Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4275 38H28.4565V40.9636H31.4275V38Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4275 43.9268H28.4565V46.8904H31.4275V43.9268Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8841 38H32.9131V40.9636H35.8841V38Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3418 38H37.3708V40.9636H40.3418V38Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8841 43.9268H32.9131V46.8904H35.8841V43.9268Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3418 43.9268H37.3708V46.8904H40.3418V43.9268Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.971 38H45V40.9636H47.971V38Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.971 43.9268H45V46.8904H47.971V43.9268Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4275 38H49.4565V40.9636H52.4275V38Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4275 43.9268H49.4565V46.8904H52.4275V43.9268Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8841 38H53.9131V40.9636H56.8841V38Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3418 38H58.3708V40.9636H61.3418V38Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8841 43.9268H53.9131V46.8904H56.8841V43.9268Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3418 44H58.3708V46.9636H61.3418V44Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 38H7.25C6.55964 38 6 38.6716 6 39.5C6 40.3284 6.55964 41 7.25 41H9.75C10.4404 41 11 40.3284 11 39.5C11 38.6716 10.4404 38 9.75 38Z",
    fill: "#55DEFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 13,
    r: 5,
    fill: "#EB982A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_10250",
    x1: 35,
    y1: 34,
    x2: 35,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeviceSwitchWarning);
export default __webpack_public_path__ + "static/media/img_device_switch_warning.11e1e04343963c0ec029b7eac06ee0c5.svg";
export { ForwardRef as ReactComponent };